'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


exports.default = routerReducer;

var _reactRouterRedux = require('react-router-redux');

var initialState = {
    locationBeforeTransitions: null
};

/**
 * From react-router-redux source:
 *
 * This reducer will update the state with the most recent location history
 * has transitioned to. This may not be in sync with the router, particularly
 * if you have asynchronously-loaded routes, so reading from and relying on
 * this state it is discouraged.
 */
function routerReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (action.type === _reactRouterRedux.LOCATION_CHANGE) {
        return _extends({}, state, {
            locationBeforeTransitions: action.payload
        });
    }
    return state;
}


//////////////////
// WEBPACK FOOTER
// ./src/client/reducers/routingImmutableReducer.js
// module id = 2043
// module chunks = 0